module.exports = __webpack_public_path__ + "img/b.73bccb0c.png";